import { startTest } from '../../test/util.js';
import './styleGuideSpec.js';

// delay for a few seconds, so we can see the shell
setTimeout(
  startTest,
  5000,
);
